import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SKELETON_COUNT = 9;

export const FixturesSkeleton = () => {
    return (
        <>
            <Skeleton width={200} height={24} />
            <Skeleton
                className="fixtures__item-skeleton"
                count={SKELETON_COUNT}
            />
        </>
    );
};
